import { createAction } from '@reduxjs/toolkit';

export const requestViewMessageOverview = createAction('request/ViewMessageOverview');
export const requestViewMessages = createAction('request/ViewMessages');
export const requestCreateMessage = createAction('request/CreateMessage');
export const requestDeleteMessage = createAction('request/DeleteMessage');
